import React, { PureComponent } from 'react';

import { loadData } from './VisState';

import AreaChart from '../../Component/AreaChart';

import './Vis.scss';

class ProductionVis extends PureComponent {

  componentDidMount() {
    this.props.dispatch(loadData());
  }

  render() {
    return (
      <div className='bkr--productionvis'>
        { !this.props.loading  && <AreaChart data={this.props.data} />}
      </div>);
  }
};

export default ProductionVis;



// WEBPACK FOOTER //
// ./src/modules/ProductionVis/Vis.js